// test121
(121 && 0);
